/**
 * @author caijianjia
 * @date 2020/3/25 5:22 下午
 */

// 获取接口数据
export function getUrlData ({ url }) {
  return request({
    url,
    method: 'get'
  })
}

import store from '../store'
import request from '../config/network/requestUcenterApiService'
import {apiUpdate} from './localdata'
//import { Message,MessageBox } from 'element-ui';

/**
 * 课件管理
 */

// 新建课件
export function addResult ({
  clientsId,
  categoryId = 0,
  name,
  title,
  type,
  ...params
}) {
  return request({
    url: `api/courseware/result?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clientsId,
      category_id: categoryId,
      name,
      title,
      type,
      ...params
    }
  })
}

// 删除课件
export function deleteResult ({ id, clientsId }) {
  return request({
    url: `api/courseware/result/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改课件 - 排序
export function updateResultOrder ({
                                     id,
                                     clientsId,
                                     order
                                   }) {
  return request({
    url: `api/courseware/result/${id}?clients_id=${clientsId}`,
    method: 'patch',
    data: {
      clients_id: clientsId,
      order
    }
  })
}

// 复制课件
export function copyResult ({
                              src_id,
                              clientsId,
                              categoryId = 0
                            }) {
  return request({
    url: `api/courseware/result/copy?clients_id=${clientsId}`,
    method: 'post',
    data: {
      src_id,
      tar_category_id: categoryId
    }
  })
}

// 课件批量上架
export function isOnlineResult ({
                                  id,
                                  is_online,
                                  clientsId
                                }) {
  return request({
    url: `api/courseware/result-multi/is-online?clients_id=${clientsId}`,
    method: 'put',
    data: {
      id,
      is_online
    }
  })
}

// 录制课件批量上架
export function recordIsOnlineResult ({
                                        id,
                                        record_is_online,
                                        clientsId
                                      }) {
  return request({
    url: `api/courseware/result-multi/is-online?clients_id=${clientsId}`,
    method: 'put',
    data: {
      id,
      record_is_online
    }
  })
}
// 修改课件
export async function updateResult ({
  id,
  clientsId,
  categoryId = 0,
  name,
  title,
  type,
  method,
  noLock,
  ...params
}) {
  let data={
    url: `api/courseware/result/${id}?clients_id=${clientsId}`,
    method: method || 'put',
    noLock,
    data: {
      clients_id: clientsId,
      category_id: categoryId,
      name,
      title,
      type,
      ...params
    }
  }
  return apiUpdate(data,id);
}

// 获取课件列表
export function getResultList ({
  id,
  search,
  clientsId,
  categoryId,
  package_status,
  ...params
}) {
  let url = 'api/courseware/result?'
  if (search) {
    url += `&like[name]=${search}`
  }
  if(package_status){
    url += `&equal[package_status]=${package_status}`
  }
  return request({
    url,
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[category_id]': categoryId,
      'equal[id]': id,
      'order[order]': 'desc',
      ...params
    }
  })
}

// 获取课件详情
export function getResultDetail ({
 id,
 clientsId,
 config_type
}) {
  //console.log(`api/courseware/result/${id}`);
  //console.log(`clientsId`,clientsId);
  //console.log(`config_type`,config_type);

  return request({
    url: `api/courseware/result/${id}`,
    method: 'get',
    params: {
      clients_id: clientsId,
      config_type
    }
  })
}

// 获取课件附件详情 通用版本id
export function getResultRecordDetail ({ resultId, id, clientsId }) {
  return request({
    url: `api/courseware/result-attr/${resultId}/${id}?clients_id=${clientsId}`,
    method: 'get',
    params: {
      clients_id: clientsId
    }
  })
}

// 获取分享地址
export function getShareAddress ({ id, clientsId, password }) {
  return request({
    url: `api/courseware/result/${id}/share`,
    method: 'get',
    params: {
      clients_id: clientsId,
      password
    }
  })
}

// 获取分享内容
export function getShareContent ({ id, password }) {
  return request({
    url: 'api/courseware/result/share-view',
    method: 'post',
    headers:{'Cache-Control': 'no-cache'},
    data: {
      password,
      id
    }
  })
}

// 获取打包记录
export function getResultPackList ({ usersId, clientsId, resultId }) {
  return request({
    url: 'api/courseware/result-pack',
    method: 'get',
    params: {
      users_id: usersId,
      clients_id: clientsId,
      'equal[result_id]': resultId
    }
  })
}

// 获取打包记录详情
export function getResultPackDetail ({ id, usersId, clientsId }) {
  return request({
    url: `api/courseware/result-pack/${id}`,
    method: 'get',
    params: {
      users_id: usersId,
      clients_id: clientsId
    }
  })
}

// 打包时获取单价
export function getPacketPrice ({id,clientsId}) {
  return request({
    url: `api/courseware/result/${id}/packetPrice?clients_id=${clientsId}`,
    method: 'get'
  })
}

// 打包发布
export function sendPacket ({id, clientsId, course_auth_token, cocos_remote}) {
  return request({
    url: `api/courseware/result/${id}/packet?clients_id=${clientsId}`,
    method: 'post',
    data: {course_auth_token, cocos_remote}
  })
}

// 打包状态
export function getPacketResult ({resultId, attrId, course_auth_token}) {
  return request({
    url: `api/courseware/result-attr/${resultId}/${attrId}/packet-status`,
    method: 'get',
    params: {course_auth_token}
  })
}

// 获取微信录音凭证
export function getAudioRecord({clientsId}){
  return request({
    url: `api/cross-platform/audio-record`,
    method: 'post',
    data: {
      clients_id: clientsId
    }
  })
}

// 获取微信已经录音好的文件
export function getAudioRecordUrl({item}){
  return request({
    url: `api/cross-platform/audio-record/${item}`,
    method: 'get'
  })
}

/*
 获取课件/模版对应的ppt导入记录
 @params id 课件或模版id
 @params source 1 我的课件 2 我的模板 3 公共模板 4 游戏练习
*/
export function getPPTList({
   id,
   source,
   clientsId
}){
  return request({
    url: `api/service/ppt2h5-result/${id}?clients_id=${clientsId}`,
    method: 'get',
    params: {source}
  })
}
/*
 修改PPT状态
 @params resources_id ppt唯一标识
 @params status 状态 0 等待 1转码成功 2 转码成功并插入PPT保存 3 失败 4 已取消(插入点击取消状态变为取消)
*/
export function updatePPTStatus({clientsId, resources_id,  status}){
  return request({
    url: `api/service/ppt2h5/${resources_id}?clients_id=${clientsId}`,
    method: 'put',
    data: {
      status,
      clients_id: clientsId
    }
  })
}


/***
 * 修改课件
 * @param 课件附件id
 */
export function updateResultIsOnline ({
  resultId,
  attrId,
  clientsId,
  is_online,
  ...params
}) {
  return request({
    url: `api/courseware/result-attr/${resultId}/${attrId}/is-online?clients_id=${clientsId}`,
    method: 'put',
    data: {
      clients_id: clientsId,
      is_online,
      ...params
    }
  })
}

/*
 下载课件（打包）
 @params resultId 课件id
*/
export function getCombinePack({
 resultId,
 clientsId
}){
  return request({
    url: `api/courseware/combine-pack/result/${resultId}?clients_id=${clientsId}`,
    method: 'get'
  })
}

/*
 下载课件（获取打包状态）
 @params resultId 课件id
*/
export function getCombinePackStatus({
 resultId,
 clientsId
}){
  return request({
    url: `api/courseware/combine-pack/result/${resultId}/packet-status?clients_id=${clientsId}`,
    method: 'get'
  })
}

/*
 下载课件（获取课件内容）
 @params url 课件url
*/
export function getCombinePackDownload({
 url,
 clientsId
}){
  return request({
    url: `api/courseware/combine-pack/download?clients_id=${clientsId}`,
    method: 'get',
    params: {
      url
    }
  })
}

/*
 获取心跳
*/
export function getHeart(timestamp){
  return request({
    url: 'api/service/heartbeat',
    method: 'get',
    params: { source: 'management.schoolcenter', create_timestamp:timestamp }
  })
 }

/*
 保存课件复制节点数据
 https://ucenter.yunkedun.com/api/courseware/cache/save
 字段	类型	备注
key	string	是	key键值(最好前面加个字母如P等，不然是浮点数字，后端精度获取会不准确)
data	string	是	数据
*/
export function cacheSet(data){
  //先获取是否有本地唯一ID
  let key=localStorage.getItem("lessonOperKey");
  let strSize=(data.length/1024).toFixed(0);

  //不存在则设置
  if(!key){
    let date=new Date();
    let datetime=date.getFullYear()+""+date.getMonth()+""+date.getDate()+""+date.getHours()+""+date.getMinutes()+""+date.getSeconds();
    key="lessonOper_"+store.state.initConfig.school_id+"_"+datetime+"_"+Math.floor(Math.random()*999999);//设置本机ID；
    localStorage.setItem("lessonOperKey",key);
  }

  //如果数据小于4096K，则保存到本地
  console.log("当前strSize：",strSize);
  if(strSize<1024){
    //将数据保存至本地
    localStorage.setItem(key,data);
    //设置当前操作时间；
    localStorage.setItem("lessonOperTime",new Date().getTime());
    return strSize;
  }
  localStorage.removeItem(key);//清除本地数据
  //否则通过服务端存储
  return request({
    url: 'api/courseware/cache/save',
    method: 'post',
    data: {key,data}
  })
}
 
/*
 获取课件复制节点数据
 http://ucenter.yunkedun.com/api/courseware/cache/get?key={key}
 字段	类型	备注
key	string	key键值
data	string	数据
*/
export  function cacheGet(){
  let key=localStorage.getItem("lessonOperKey");
  return request({
    url: 'api/courseware/cache/get',
    method: 'get',
    params: {key: key}
  })
}

/*
 清除缓存数据
*/
export  function cacheClear(){
  let key=localStorage.getItem("lessonOperKey");
  localStorage.removeItem(key);
  return request({
    url: 'api/courseware/cache/save',
    method: 'post',
    data: {key,data:{}}
  })
}